window.gsap = require('gsap').gsap;
window.ScrollTrigger = require('gsap/ScrollTrigger').ScrollTrigger;

$(function() {
	$(".service-button").hover(
		( function() { 
			$(this).children('.service-description').addClass("service-description-highlight");
		}),
		( function() {
			$(this).children('.service-description').removeClass("service-description-highlight");
			//$(`service-descr-${$(this).data('id')}`).removeClass("service-description-highlight");
		})
	);

	var descTitleList = document.getElementsByClassName("description-title");
	for (item of descTitleList) { 
		item.addEventListener("mouseover", function(event) {
			var rowEl = $(event.target).parents(".row");
			var pEl = $(rowEl).find("p");

			pEl.addClass("description-desc-highlight");
		});

		item.addEventListener("mouseout", function(event) {
			var rowEl = $(event.target).parents(".row");
			var pEl = $(rowEl).find("p");

			pEl.removeClass("description-desc-highlight");
		});
	} 

	var descDescList = document.getElementsByClassName("description-desc");
	for (item of descDescList) { 
		item.addEventListener("mouseover", function(event) {
			var rowEl = $(event.target).parents(".row");
			var h3El = $(rowEl).find("h3");

			h3El.addClass("description-desc-highlight");
		});

		item.addEventListener("mouseout", function(event) {
			var rowEl = $(event.target).parents(".row");
			var h3El = $(rowEl).find("h3");

			h3El.removeClass("description-desc-highlight");
		});
	}

	gsap.config({ nullTargetWarn: false });
	gsap.registerPlugin(ScrollTrigger);
	gsap.fromTo('#intro .section-title', {
	    y: 50, 
	    opacity: 0,
	} , 
	{
	    y: 0, 
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#intro',
	        start: 'top-=150 top+=150',
	        end: 'center center',
	        // markers: true,
	    }
	});gsap.fromTo('#intro .section-subtitle', {
	    y: 50, 
	    opacity: 0,
	} , 
	{
	    y: 0, 
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#intro',
	        start: 'top-=150 top+=150',
	        end: 'center center',
	        // markers: true,
	    }
	});

	gsap.fromTo('#intro .intro-desc-cont', {
	    y: 50, 
	    opacity: 0,
	} , 
	{
	    y: 0, 
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#intro',
	        start: 'top-=150 top+=150',
	        end: 'center center',
	        // markers: true,
	    }
	});

	gsap.fromTo('#services .service-1', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#services .service-1',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	        // markers: true,
	    }
	});

	gsap.fromTo('#services .service-2', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#services .service-2',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	    }
	});

	gsap.fromTo('#services .service-3', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#services .service-3',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	    }
	});

	gsap.fromTo('#services .service-4', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#services .service-4',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	    }
	});

	gsap.fromTo('#services .service-5', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#services .service-5',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	    }
	});

	gsap.fromTo('#services .service-6', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#services .service-6',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	    }
	});

	gsap.fromTo('#hero-banner', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#hero-banner',
	        start: 'top-=150 top+=150',
	        end: 'center center',
	    }
	});

	gsap.fromTo('#detailed-description  .description-title-container', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#detailed-description',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	    }
	});

	gsap.fromTo('#detailed-description  .description-desc-container', {
	    opacity: 0,
	} , 
	{
	    opacity: 1,
	    stagger: 0.1,
	    duration: 0.1,
	    scrollTrigger: {
	        trigger: '#detailed-description',
	        start: 'top-=250 top+=250',
	        end: 'center center',
	    }
	});

	
});